<template>
  <section class="tu-construye-features">
    <DsChip label="Características exclusivas" variant="orange" />

    <DsFeaturesSection
      title-base="Tus características"
      title-highlight="exclusivas"
      title-id="tu-construye-features-title"
      :features="features"
    >
      <template #description>
        <DsText as="body3">
          Nosotros te acompañamos en cada paso para que la construcción de tu
          futuro sea segura y accesible.
        </DsText>
      </template>
    </DsFeaturesSection>
  </section>
</template>

<script setup lang="ts">
/*
  Los íconos de Alcance, Montos y Financiamiento Flexible son idénticos
  (byte a byte) a los de Hazte Dueña, así que se reutilizan en lugar de
  duplicar el asset.
*/
import homeIcon from '../../../assets/hazte-duena/ic_vivienda.svg'
import realEstateAgentIcon from '../../../assets/hazte-duena/ic_comprador.svg'
import folderCopyIcon from '../../../assets/hazte-duena/ic_expediente.svg'
import assuredWorkloadIcon from '../../../assets/tu-construye/ic_garantia.svg'
import paymentsIcon from '../../../assets/tu-construye/ic_inicio.svg'
import DsChip from '../atoms/DsChip.vue'
import DsText from '../atoms/DsText.vue'
import DsFeaturesSection from '../components/DsFeaturesSection.vue'

const features = [
  {
    id: 'scope',
    iconSrc: homeIcon,
    title: 'Alcance',
    description: 'Exclusivo para construcción o terminación de obra (no remodelación).'
  },
  {
    id: 'amounts',
    iconSrc: realEstateAgentIcon,
    title: 'Montos',
    description: 'Financiamiento desde $250 mil hasta $15.0M'
  },
  {
    id: 'guarantee',
    iconSrc: assuredWorkloadIcon,
    title: 'Tu garantía',
    description:
      'Usamos tu terreno como respaldo. Solo necesitamos que su valor sea igual o mayor a la tercera parte de lo que vas a contratar.'
  },
  {
    id: 'flexible-financing',
    iconSrc: folderCopyIcon,
    title: 'Financiamiento Flexible',
    description:
      'Te financiamos el 67% del monto total en ministraciones. Y lo mejor: al terminar, el valor de tu casa ampara el 100% de lo contratado.'
  },
  {
    id: 'calm-start',
    iconSrc: paymentsIcon,
    title: 'Inicio Tranquilo',
    // El Figma dice "ienes": errata corregida.
    description: 'Tienes 3 meses de prórroga antes de empezar tu primer pago completo.'
  }
]
</script>

<style scoped>
.tu-construye-features {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}
</style>
